<template>
  <div class="form-password col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-4">
    <div class="row">
      <div class="form-password__content col-xs-12 col-md-9">
        <div class="row">
          <form @submit.prevent="confirmPassword">
            <div class="col-xs-12 col-sm-9 form-password__text">
              <label for="upload-password" v-if="browserIE9">{{ this.$t('uploadPassword.passwordLabel') }}</label>
              <input type="password" v-model="password" name="upload-password" :placeholder="$t('uploadPassword.passwordLabel')" class="form-password__input">
            </div>
            <div class="col-xs-12 col-sm-3">
              <button type="submit" class="form-password__btn-submit" :class="[browserIE9 ? 'mg-top': '', !$store.state.isHkom ? 'bg-primary' : 'bg-primary--green']" @keyup.enter="submit">{{ $t('uploadPassword.buttonText') }}</button>
            </div>
            <slot />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepPublishButton from '../step/StepPublishButton'
import StepPublish from '../step/StepPublish'

export default {
  name: "UploadPassword",
  components: {
    StepPublishButton,
    StepPublish,
  },
  data() {
    return {
      password: null,
    }
  },
  methods: {
    confirmPassword () {
      this.$emit('submit-password', this.password)
    }
  },
  computed: {
    browserIE9() {
      return window.ltie10;
    }
  }
}
</script>

<style lang="scss">

.form-password {
  font-weight: 600;
  margin-top: 14px;

  &__content {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    padding: 10px;
    background-color: #fff;
  }

  &__text {
    font-size: 13px;

    @media (max-width: 768px) {
      text-align: center;
      margin-bottom: 9px;
    }
  }

  &__input {
    font-weight: 600;
    padding: 7px 9px;
    width: 100%;
    border-radius: 2px;
    border: 1px solid #c0c0c0;
    font-size: 14px;
  }

  .mg-top {
    margin-top: 18px;
  }

  &__btn-submit {
    width: 100%;
    color: #fff;
    border: none;
    outline: none;
    float: right;

    border-radius: 1.3px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    padding: 7px 16px;
    cursor: pointer;
    font-size: 14px;

    &:hover:not(:disabled) {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
      transform: translateY(1px);
    }

    @media (max-width: 768px) {
      padding: 7px 9px;
      float: none;
      width: 100%;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/upload-files/UploadPassword.vue